// 图书列表
import { bookList } from "@/api/addedServices/index.js";
// 获取用户信息对象
const userInfo = JSON.parse(localStorage.getItem("userInfo")) ?? {};

// 获取图书列表内容
export async function getBookListData(subject_id = "", cate_id = "") {
  let res = await bookList(userInfo.jwt, {
    // 标题搜索（模糊搜索）
    search: "",
    // 年级（学段）
    // grade_id: "",
    grade_id: subject_id,
    // 学科
    // 小学：7
    // 初中：10
    // 高中：9
    // subject_id: subject_id,
    subject_id: "",
    // 版本
    version_years: "",
    // 页码
    page: "1",
    // 条数
    psize: "6",
    // 分类id
    // 专题类 12
    // 真题类 13
    // 真题汇编 14
    // 汇编类 15
    // 专项类 16
    // 原创类 17
    // 学考类 18
    // 同步类 19
    // 工具类 20
    cate_id: cate_id,
  });
  return res;
}
